import { memo } from 'react';
import { BaseEdge, Edge, EdgeLabelRenderer, EdgeProps, getStraightPath } from '@xyflow/react';
import classnames from 'classnames';
import { RiCloseCircleFill } from 'react-icons/ri';
import { EdgeTransportInfoType } from '@lp/features/RoutePlanner/types';
import { RouteLegTypeEnum } from '@/api/apis/route';
import { AVIA_LEG_TYPES } from '@/utils/route';
import { TransportLabel } from './TransportLabel';

type StraightEdgeProps = Edge<EdgeTransportInfoType, 'straightEdge'>;

export const StraightEdge = memo(
  ({ sourceX, sourceY, targetX, targetY, markerEnd, data, label }: EdgeProps<StraightEdgeProps>) => {
    const [edgePath, labelX, labelY] = getStraightPath({ sourceX, sourceY, targetX, targetY });

    const isRightDirection = sourceX < targetX;
    const isCommercial = data?.legType === RouteLegTypeEnum.CommercialFlightAviaLeg;
    const isAir = !!data?.legType && AVIA_LEG_TYPES.includes(data.legType);

    return (
      <>
        <BaseEdge path={edgePath} markerEnd={markerEnd} style={{ strokeDasharray: isAir ? '6 1' : '' }} />
        {data ? (
          <EdgeLabelRenderer>
            <div
              style={{
                transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              }}
              className={classnames('nodrag nopan absolute bg-transparent flex flex-col items-center gap-1', {
                'h-11': isCommercial,
              })}
            >
              <TransportLabel data={data} isRightDirection={isRightDirection} label={label} />
              {!isCommercial && (
                <div className="flex gap-1 items-center">
                  <span className="text-s-sb text-base-20">{data.time}</span>
                  {data.isReposition && <span className="text-s-sb text-base-20">REP</span>}
                </div>
              )}
            </div>
          </EdgeLabelRenderer>
        ) : (
          <EdgeLabelRenderer>
            <div
              style={{
                transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              }}
              className={classnames('nodrag nopan absolute flex flex-col items-center p-1 gap-1 text-danger-50', {
                'bg-base-80': label === 'alt',
                'bg-white': label === 'main',
              })}
            >
              <RiCloseCircleFill size={8} />
            </div>
          </EdgeLabelRenderer>
        )}
      </>
    );
  },
);
